const SUFFIX = '@lift';

export function appendSuffixIfMissing(username: string): string {
  if (!username) return username;
  return username.endsWith(SUFFIX) ? username : `${username}${SUFFIX}`;
}

export function stripSuffix(username: string): string {
  if (!username) return username;
  return username.endsWith(SUFFIX) ? username.slice(0, -SUFFIX.length) : username;
}

export function hasSuffix(username: string): boolean {
  return typeof username === 'string' && username.endsWith(SUFFIX);
}

export function getSuffix(): string { return SUFFIX; }

export const ADPA99_USERNAME = 'adpa99';

export function isAdpa99Username(username?: string | null): boolean {
  if (!username) return false;
  return stripSuffix(username).toLowerCase() === ADPA99_USERNAME;
}

